import CountryUtil from "../uidispatcherapi/CountryUtil";

function getOcCountryConfig() {
	return typeof CountryUtil.getOcCountryConfig === "function" ? CountryUtil.getOcCountryConfig() : {};
}

export const isAllowingMultiOQ = (): boolean => {
	return typeof CountryUtil.isAllowingMultiOQ === "function" ? CountryUtil.isAllowingMultiOQ() : false;
};

export const getTermsAndConditionsLink = (): string | null | undefined => {
	const { ocTermsAndConditionsLink } = getOcCountryConfig() || {};
	return ocTermsAndConditionsLink;
};
export const getTermsAndConditionsLinkByFulfillmentType = (): Record<string, string> | null | undefined => {
	const { termsAndConditionsLinkByFulfillmentType } = getOcCountryConfig() || {};
	return termsAndConditionsLinkByFulfillmentType;
};
export const getPrivacyPolicyLink = (): string | null | undefined => {
	const { ocPrivacyPolicyLink } = getOcCountryConfig() || {};
	return ocPrivacyPolicyLink;
};
export const shouldShowCreditLimitToCustomer = (): boolean => {
	const { customerCreditLimit } = getOcCountryConfig() || {};
	return !!customerCreditLimit;
};
export const shouldShowFiscalReceipt = (): boolean => {
	const { enableFiscalReceipt } = getOcCountryConfig() || {};
	return !!enableFiscalReceipt;
};
export const shouldShowVatInfo = (): boolean => {
	const { alwaysShowVatInfo } = getOcCountryConfig() || {};
	return !!alwaysShowVatInfo;
};
export const isAllowedToSendCustomerDataInSurveyWithoutConsent = (): boolean => {
	const { maySendCustomerDataInSurveyWithoutConsent } = getOcCountryConfig() || {};
	return !!maySendCustomerDataInSurveyWithoutConsent;
};
export const shouldShowArticleDeliveryDate = (): boolean => {
	const { articleDeliveryDate } = getOcCountryConfig() || {};
	return !!articleDeliveryDate;
};
export const shouldShowArticleCommentToCustomer = (): boolean => {
	const { showArticleCommentToCustomer } = getOcCountryConfig() || {};
	return !!showArticleCommentToCustomer;
};
export const shouldEnableFsdVouchers = (): boolean => {
	const { fsdVouchers } = getOcCountryConfig() || {};
	return !!fsdVouchers;
};
export const shouldEnableCcVouchers = (): boolean => {
	const { ccVouchers } = getOcCountryConfig() || {};
	return !!ccVouchers;
};
export const isZeroFeeMovEnabled = (): boolean => {
	const { zeroFeeMov } = getOcCountryConfig() || {};
	return !!zeroFeeMov;
};
export const isHideMovWarningForEmployees = (): boolean => {
	const { hideMovWarningForEmployees } = getOcCountryConfig() || {};
	return !!hideMovWarningForEmployees;
};
export const shouldShowPickupDatePicker = (): boolean => {
	const { pickupDatePicker } = getOcCountryConfig() || {};
	return !!pickupDatePicker;
};
export const isTrackPaymentsDifferenceEnabled = (): boolean => {
	const { trackPaymentsDifference } = getOcCountryConfig() || {};
	return !!trackPaymentsDifference;
};
export const isDateSelectionWithConfiguredTimeslotsEnabled = (): boolean => {
	const { enableDateSelectionWithConfiguredTimeslots } = getOcCountryConfig() || {};
	return !!enableDateSelectionWithConfiguredTimeslots;
};
export const cashPaymentWarningForLicensesOrOrderTotal = (): NoCashPaymentWarningConfig => {
	const { cashPaymentWarningForLicensesOrOrderTotal } = getOcCountryConfig() || {};
	return cashPaymentWarningForLicensesOrOrderTotal || {};
};
export const getDaysToOrderInAdvance = (): number => {
	const { daysToOrderInAdvance } = getOcCountryConfig() || {};
	return daysToOrderInAdvance || 29;
};

export const isAnonCartEnabled = (): boolean => {
	const { anonCart } = getOcCountryConfig() || {};
	return !!anonCart;
};

export const shouldHidePriceDialog = (): boolean => {
	const { hidePriceDialog } = getOcCountryConfig() || {};
	return !!hidePriceDialog;
};

export const shouldUsePickupTimeslots = (): boolean => {
	const { usePickupTimeslots } = getOcCountryConfig() || {};
	return !!usePickupTimeslots;
};

export type NoCashPaymentWarningConfig = {
	licenses: string[] | [];
	orderTotal: string | null;
};
